import { Divider, MenuItem } from '@mui/material';
import { Replay } from '@mui/icons-material';
import { EditPenIcon } from '@/assets/icons';
import { useTranslation } from 'react-i18next';

import { DashboardMenuItem } from '../../DashboardMenuItem';
import { Menu } from '../../Menu';
import { SimulationGroup } from '@thive/fddm-types';

type Props = {
  simulation: SimulationGroup;
  onEditClicked:() => void;
  onRerunClicked:() => void;
};

export const HeaderMenu = ({ simulation, onEditClicked, onRerunClicked }: Props) => {
  const { t } = useTranslation('interface');

  return (
    <Menu>
      <DashboardMenuItem url={simulation.dashboardUrl} />
      <Divider />
      <MenuItem
        onClick={onRerunClicked}
        disabled={simulation.status !== 'COMPLETED' && simulation.status !== 'PARTIALLY_COMPLETED'}
      >
        <Replay />
        {t('simulation.run_card.rerun_button.label')}
      </MenuItem>
      <MenuItem onClick={onEditClicked}>
        <EditPenIcon />
        {t('simulation.run_card.edit_button.label')}
      </MenuItem>
    </Menu>
  );
};
